declare global {
  interface Window {
    __APP_CONFIG__?: {
      API_URL?: string;
    };
  }
}

function resolveApiUrl(): string {
  const runtimeApiUrl = window.__APP_CONFIG__?.API_URL?.trim();
  if (runtimeApiUrl) {
    return runtimeApiUrl;
  }

  const host = window.location.host;

  if (host.includes("localhost") || host.includes("127.0.0.1")) {
    return "http://localhost:3011/api/v1";
  }

  if (host.includes("devtunnels.ms")) {
    // Fallback: se o front estiver em *-3000.*.devtunnels.ms,
    // tenta o backend no mesmo padrão com porta 3011 (quando o tunnel for compartilhado).
    // Preferível definir API_URL via config.js no Docker.
    const guessed = host.replace("-3000.", "-3011.");
    if (guessed !== host) {
      return `${window.location.protocol}//${guessed}/api/v1`;
    }
  }

  if (host.includes("sandbox.")) {
    return "https://api.sandbox.calendariosanitariobovino.com.br/api/v1";
  }

  return "https://api.calendariosanitariobovino.com.br/api/v1";
}

const config = {
  API_URL: resolveApiUrl(),
};

export default config;
